﻿(function (angular, gajus) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyCementAttribute", function () {
    /*
     * Cement attribute - prevent a CSS attribute changing after directive
     * is run, except during orientation change.
     *
     * Intended for mobile Chrome only, to prevent scrolling from
     * triggering changes for CSS heights based on vh units.
     */

    var isAndroid = /android/i.test(navigator.userAgent);
    var isIos = /iPad|iPhone|iPod/i.test(navigator.userAgent);
    var isChrome = /Chrome|CriOS/i.test(navigator.userAgent);

    return {
      scope: {
        attribute: "@tyCementAttributeWhich",
      },
      link: function (scope, $element) {
        // don't do this if the browser doesn't have the issue to begin with
        if (!(isChrome && (isAndroid || isIos))) {
          return;
        }

        var attribute = scope.attribute ? scope.attribute : "height";

        $element.css(attribute, $element.css(attribute));

        var OCE = gajus.orientationchangeend({});
        OCE.on("orientationchangeend", function () {
          $element.css(attribute, "");
          $element.css(attribute, $element.css(attribute));
        });
      },
    };
  });
})(window.angular, window.gajus);
